import { IStore } from 'store/configureStore';
import { selectIsLoadingClientConfiguration } from 'store/entities/clients/selectors/clientsSelectors';
import { selectIsActivitiesLoading } from 'store/entities/configuration/configurationSelectors';

export const selectIsSheetDetailLoading = (state: IStore) =>
    state.components.sheetDetails.loading
    || selectIsLoadingClientConfiguration(state)
    || selectIsActivitiesLoading(state);
